/**
 * @property {string|null} id
 * @property {string|null} label
 * @property {string|null} color
 */
export default class Tag {
    constructor() {
        this.id = null;
        this.label = null;
        this.color = null;
    }

    /**
     * Returns an instance of `Tag` hydrated using data from given `api_resource`.
     *
     * @param {object} api_resource
     * @returns {Tag}
     */
    static fromAPI(api_resource) {
        return Object.assign(new Tag(), {
            id: api_resource.id,
            label: api_resource.label,
            color: api_resource.color
        });
    }
}
